// extracted by mini-css-extract-plugin
export default {"container":"style_container__R5XsT","title":"style_title__76P4t","text":"style_text__kxnt0","button":"style_button__NV3BE","linkButton":"style_linkButton__Y3tdq"};